import React from "react";

const selectorStyle = {
  color: "#00B0F5",
  width: "120px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  cursor: "pointer",
};

const SelectLumpSumCategory = ({
  methodType,
  onClick,
  currentConcessionData,
}) => {
  const displayValue = methodType || currentConcessionData?.subSubCategoryDisplayValue;
  const isUpdating = Boolean(displayValue);
  const label = isUpdating ? `Update - ${displayValue}` : "Select";

  return (
    <div
      onClick={onClick}
      className="bold-heading-label"
      style={selectorStyle}
      title={label}
    >
      {label}
    </div>
  );
};

export default SelectLumpSumCategory;
